import axios from 'axios';

import getBaseUrl from './getBaseUrl';

const options = { credentials: 'include' };

const getUrl = (path) => `${getBaseUrl()}product${path[0] !== '/' ? '/' : ''}${path}`;

const ProductSvc = {
  getPlan: () => axios.get(getUrl(`/planDetails`, options)),
  getUserCount: () => axios.get(getUrl(`/entitlements/USER_MGMT/CREATE`, options)),
  getSmsSendEntitlement: () => axios.get(getUrl(`/entitlements/SMS/SEND`, options)).then((res) => res.data),
};

export default ProductSvc;
